import { render, staticRenderFns } from "./recordingsList.vue?vue&type=template&id=6c08b297&scoped=true&"
import script from "./recordingsList.vue?vue&type=script&lang=js&"
export * from "./recordingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08b297",
  null
  
)

export default component.exports